module.exports = __webpack_public_path__ + "static/textarea-helptext-dont-84205ae213fd081e987024e65bc5cd72.png";